import { getToken } from "../../../util/Cookies";

import axiosInstance from "../../../util/axiosInstance";

//this is api for preist post, get and delete
export const addPriestToCartAPI = async ({
  event_id,
  priest_id,
  service_id,
}) => {
  const token = getToken();
  console.log("got here for req", event_id);

  try {
    const response = await axiosInstance.post(
      "/cart/priest",
      {
        event_id,
        priest_id,
        service_id,
      },
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log("got error for api");
    // Axios error handling
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const deletePriestFromCartAPI = async (cartItemId) => {
  const token = getToken();

  try {
    const response = await axiosInstance.delete(`/cart/priest/${cartItemId}`, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    console.log("deletePriestFromCartAPI",response)
    return response.data;
  } catch (error) {
    console.log("got error for delete API");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const refundpreistfromcartapi = async(event_id,provider_id) =>{
  try {
    const request = await axiosInstance.post("/cart/refundpriest",{event_id,provider_id})
    return request.data
  } catch (error) {
     console.log("got error for refund ");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
}

export const getPriestToCartAPI = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/cart/priest", {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.log("got error for addEmptyPriestToCartAPI");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

//this is api for tenthouse post get and delete

export const addTentToCartAPI = async ({
  event_id,
  tent_provider_id,
  items,
}) => {
  try {
    const response = await axiosInstance.post("/cart/tent", {
      event_id,
      provider_id: tent_provider_id,
      items,
    });

    return response.data;
  } catch (error) {
    console.error("Error in addTentToCartAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const fetchTentCartAPI = async () => {
  try {
    const response = await axiosInstance.get("/cart/tent/grouped");
    console.log("tenthouse", response);
    return response.data;
  } catch (error) {
    console.error("tenthouse Error in fetchTentCartAPI:", error);
    return [];
  }
};
export const deleteTentCartItemAPI = async (event_id, provider_id) => {
  try {
    const response = await axiosInstance.delete("/cart/tent", {
      data: {
        event_id,
        provider_id
      }
    });
    console.log("Deleted TentCartItem:", response);
    return response.data;
  } catch (error) {
    console.error("Error in deleteTentCartItemAPI:", error);
    throw error;
  }
};

export const updateTentCartItemAPI = async(event_id, provider_id, items) => {
  try {
    console.log( "response1",event_id,
      provider_id,
      items)
    const response = await axiosInstance.put("/cart/tent/item", {
      event_id,
      provider_id,
      items
    });
    console.log("Tent cart item updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating tent cart item:", error.response || error);
    throw error;
  }
};


export const getTentHouseProviderServicesAPI = async (provider_id) => {
  try {
    // Since this is a GET request, provider_id goes into the URL path
    const response = await axiosInstance.get(`/tent-house/providers/${provider_id}/services`);
    // console.log("Fetched TentHouse Provider Services:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in getTentHouseProviderServicesAPI:", error);
    throw error;
  }
};

export const refundtentproviderfromcartapi = async(event_id,provider_id) =>{
  try {
    const request = await axiosInstance.post("/cart/refundtentprovider",{event_id,provider_id})
    return request.data
  } catch (error) {
     console.log("got error for refund ");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
}
//catering

export const addCateringToCartAPI = async ({
  event_id,
  provider_id,
  items,
}) => {
  try {
    const response = await axiosInstance.post("/cart/catering", {
      event_id,
      provider_id: provider_id,
      items,
    });

    return response.data;
  } catch (error) {
    console.error("Error in addCateringToCartAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};
export const editCateringToCartAPI = async ({
  event_id,
  provider_id,
  items,
}) => {
  try {
    const response = await axiosInstance.put("/cart/catering", {
      event_id,
      provider_id: provider_id,
      items,
    });

    return response.data;
  } catch (error) {
    console.error("Error in addCateringToCartAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};


export const fetchCateringCartAPI = async() => {
try {
  const response = await axiosInstance.get("/cart/catering/grouped")
  //  console.log("catering", response);
    return response;
} catch (error) {
  console.error("catering Error in cateringfetchapi:", error);
}
}

export const deleteCateringCartItemAPI = async (event_id, provider_id) => {
  try {
    const response = await axiosInstance.delete("/cart/catering", {
      data: {
        event_id: event_id,
        provider_id: provider_id,
      },
    });

    console.log("Successfully deleted catering cart:", response);
  } catch (error) {
    console.error("Error in deleteCateringCartItemAPI:", error);
  }
};

export const refundcateringfromcartapi = async(event_id,provider_id) =>{
  try {
    const request = await axiosInstance.post("/cart/refundcateringprovider",{event_id,provider_id})
    return request.data
  } catch (error) {
     console.log("got error for refund ");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
}